<template>
  <c-input
    as="multiselect"
    class="multiselect-multiple"
    multiple
    v-model="selectedMediaOwnerScreenTags"
    :placeholder="holder"
    :close-on-select="false"
    :preselect-first="false"
    :show-labels="false"
    :options="mediaOwnerScreenTags"
    label="name"
    track-by="id"
  />
</template>

<script>
export default {
  props: {
    mediaOwnerScreenTags: Array,
    value: Array,
    holder: {
      default: 'Select'
    }
  },

  data () {
    return {
      tagOptions: []
    }
  },

  computed: {
    // This component is passed its tags in by the parent component - because it's used on the screens page specifically.
    // For a generic select based on the authenticated user's abilities, see MediaOwnerScreenTagSelectGeneric.vue
    selectedMediaOwnerScreenTags: {
      get () {
        const ids = this.value.map(({ id }) => id)

        return this.mediaOwnerScreenTags.filter(({ id }) => {
          return ids.includes(id)
        })
      },

      set (options) {
        this.$emit('input', options)
      }
    }
  },
}
</script>
